interface LogoProps {
  className?: string;
}

export function EmergingMarketLogo({ className = "w-full h-full" }: LogoProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 50 50"
      className={className}
    >
      <path 
        fill="currentColor" 
        d="M42.9,8.1c0-.4-.4-.8-.8-.8h-6.8c-.4,0-.8.3-.8.8l-.4,13-8.3,4.7v-4.3c0-.5-.4-.8-.8-.8s-.3,0-.4.1l-7.9,4.9v-4.2c0-.5-.4-.8-.8-.8s-.3,0-.4.1l-9.1,5.7c-.2.1-.4.4-.4.7v14.8c0,.5.4.8.8.8h36.6c.5,0,.8-.4.8-.8h0s-1.2-33.9-1.2-33.9h0ZM41.3,8.9v3.1c.1,0-5.3,0-5.3,0v-3.1h5.3ZM35.7,41.1l.4-16c0-.5-.3-.8-.8-.8h0c-.4,0-.8.4-.8.8l-.4,16.1H7.5v-13.5l7.5-4.7v4.2c0,.5.4.8.8.8s.3,0,.4-.1l7.9-4.9v4.2c0,.5.4.8.8.8s.3,0,.4-.1l9.9-5.6c.2-.1.4-.4.4-.7l.3-7.9h5.6l1,27.5h-6.8,0Z" 
      />
      <path 
        fill="currentColor" 
        d="M13.8,30.6h-3.4c-.5,0-.8.4-.8.8v2.7c0,.5.4.8.8.8h3.4c.5,0,.8-.4.8-.8v-2.7c0-.5-.4-.8-.8-.8M12.9,33.3h-1.7v-1h1.7v1Z" 
      />
      <path 
        fill="currentColor" 
        d="M22.4,30.6h-3.4c-.5,0-.8.4-.8.8v2.7c0,.5.4.8.8.8h3.4c.5,0,.8-.4.8-.8v-2.7c0-.5-.4-.8-.8-.8M21.5,33.3h-1.7v-1h1.7v1Z" 
      />
      <path 
        fill="currentColor" 
        d="M31.1,30.6h-3.4c-.5,0-.8.4-.8.8v2.7c0,.5.4.8.8.8h3.4c.5,0,.8-.4.8-.8v-2.7c0-.5-.4-.8-.8-.8M30.3,33.3h-1.7v-1h1.7v1Z" 
      />
    </svg>
  );
}